import gsap from 'gsap';
import { appartenenze } from './appartenenze';

export const calcolaAppartenenza = function( appId ) {
    for (let i = 0; i < appartenenze.length; i++)
        if ( appId >= appartenenze[i].min && appId <= appartenenze[i].max )
            return i++;
    return false;
};

export const btnFade = ( btn, direction ) => {
    const op = direction === 'in' ? 1 : 0;
    const time = direction === 'in' ? 0.1 : 0.3;

    TweenMax.to(btn, time, {
        autoAlpha: op,
        ease: Power3.easeInOut
    });
};



/** WEBPACK FOOTER **
 ** ./components/utils.js
 **/